// Original filename: utils.ts
/* eslint-disable no-plusplus */
import { useState, useCallback } from 'react';
import { KEY_VALUES } from '../utils';
var searchWords = '';
export function onMenuKeyDown(event, events) {
  var down = events.down,
    up = events.up,
    enter = events.enter,
    del = events.del,
    esc = events.esc,
    right = events.right,
    left = events.left,
    highlight = events.highlight;
  if (highlight) {
    var keyCode = event.keyCode;
    if (keyCode >= 65 && keyCode <= 90 || keyCode >= 97 && keyCode <= 122) {
      event.stopPropagation();
      event.preventDefault();
      searchWords = searchWords + event.key;
      highlight === null || highlight === void 0 ? void 0 : highlight(event, searchWords);
      setTimeout(function () {
        searchWords = '';
      }, 500);
      return;
    }
  }
  switch (event.key) {
    // down
    case KEY_VALUES.DOWN:
      down === null || down === void 0 ? void 0 : down(event);
      event.preventDefault();
      break;
    // up
    case KEY_VALUES.UP:
      up === null || up === void 0 ? void 0 : up(event);
      event.preventDefault();
      break;
    // enter
    case KEY_VALUES.ENTER:
    case KEY_VALUES.SPACE:
      enter === null || enter === void 0 ? void 0 : enter(event);
      event.preventDefault();
      break;
    // delete
    case KEY_VALUES.BACKSPACE:
      del === null || del === void 0 ? void 0 : del(event);
      break;
    // esc | tab
    case KEY_VALUES.ESC:
    case KEY_VALUES.TAB:
      esc === null || esc === void 0 ? void 0 : esc(event);
      break;
    // left arrow
    case KEY_VALUES.LEFT:
      left === null || left === void 0 ? void 0 : left(event);
      break;
    // right arrow
    case KEY_VALUES.RIGHT:
      right === null || right === void 0 ? void 0 : right(event);
      break;
    default:
  }
}
export var useFocusItemValue = function useFocusItemValue(defaultFocusItemValue, visible, props) {
  var items = props.items,
    _props$labelKey = props.labelKey,
    labelKey = _props$labelKey === void 0 ? 'label' : _props$labelKey,
    _props$valueKey = props.valueKey,
    valueKey = _props$valueKey === void 0 ? 'value' : _props$valueKey,
    _props$disabledItemVa = props.disabledItemValues,
    disabledItemValues = _props$disabledItemVa === void 0 ? [] : _props$disabledItemVa,
    callback = props.callback;
  var _useState = useState({
      keyboard: false,
      value: defaultFocusItemValue
    }),
    focusItemValue = _useState[0],
    setFocusItemValue = _useState[1];
  var getFocusableMenuItems = useCallback(function (keyWord) {
    if (!items || items.length === 0) {
      return [];
    }
    if (keyWord) {
      var newItems = items.filter(function (item) {
        var _item$labelKey;
        return !item.disabled && !(disabledItemValues !== null && disabledItemValues !== void 0 && disabledItemValues.includes(item[valueKey])) && ((_item$labelKey = item[labelKey]) === null || _item$labelKey === void 0 ? void 0 : _item$labelKey.toString()[0].toLowerCase()) === keyWord.toLowerCase();
      });
      return newItems;
    }
    return items.filter(function (item) {
      return !item.disabled && !(disabledItemValues !== null && disabledItemValues !== void 0 && disabledItemValues.includes(item[valueKey]));
    });
  }, [items, disabledItemValues]);

  /**
   * Get the index of the focus item.
   */
  var findFocusItemIndex = useCallback(function (callback, keyWord, isUp) {
    var items = getFocusableMenuItems(keyWord);
    if (isUp && !visible) {
      items = items.reverse();
    }
    for (var i = 0; i < items.length; i += 1) {
      var _items$i;
      if (focusItemValue.value === ((_items$i = items[i]) === null || _items$i === void 0 ? void 0 : _items$i[valueKey])) {
        callback(items, i);
        return;
      }
    }
    callback(items, -1);
  }, [focusItemValue, getFocusableMenuItems, valueKey]);
  var focusHighlightItem = useCallback(function (event, searchWords) {
    findFocusItemIndex(function (items, index) {
      var nextIndex = index + 2 > items.length ? 0 : index + 1;
      var focusItem = items[nextIndex];
      if (typeof focusItem !== 'undefined') {
        setFocusItemValue({
          keyboard: true,
          value: focusItem[valueKey]
        });
        callback === null || callback === void 0 ? void 0 : callback(focusItem[valueKey], event);
      }
    }, searchWords);
  }, [callback, findFocusItemIndex, valueKey]);
  var focusNextMenuItem = useCallback(function (event) {
    findFocusItemIndex(function (items, index) {
      var nextIndex = index + 2 > items.length ? 0 : index + 1;
      var focusItem = items[nextIndex];
      if (typeof focusItem !== 'undefined') {
        setFocusItemValue({
          keyboard: true,
          value: focusItem[valueKey]
        });
        callback === null || callback === void 0 ? void 0 : callback(focusItem[valueKey], event);
      }
    });
  }, [callback, findFocusItemIndex, valueKey]);
  var focusPrevMenuItem = useCallback(function (event) {
    findFocusItemIndex(function (items, index) {
      var nextIndex = index === 0 ? items.length - 1 : index - 1;
      var focusItem = items[nextIndex];
      if (typeof focusItem !== 'undefined') {
        setFocusItemValue({
          keyboard: true,
          value: focusItem[valueKey]
        });
        callback === null || callback === void 0 ? void 0 : callback(focusItem[valueKey], event);
      }
    });
  }, [callback, findFocusItemIndex, valueKey]);
  var handleKeyDown = useCallback(function (event) {
    onMenuKeyDown(event, {
      down: focusNextMenuItem,
      up: focusPrevMenuItem,
      highlight: focusHighlightItem // query based on the first letter
    });
  }, [focusNextMenuItem, focusPrevMenuItem]);
  return {
    focusItemValue: focusItemValue,
    setFocusItemValue: setFocusItemValue,
    onKeyDown: handleKeyDown,
    findFocusItemIndex: findFocusItemIndex
  };
};